import { Link } from "react-router-dom";

export interface Crumb {
  name: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <nav aria-label="面包屑导航" className="font-label text-sm text-foreground-600">
      <ol className="flex flex-wrap items-center gap-x-1.5 gap-y-1">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 transition-colors hover:text-primary-700 cursor-pointer">
            <i className="ri-home-4-line" />
            首页
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.name}-${index}`} className="flex items-center gap-x-1.5">
              <i className="ri-arrow-right-s-line text-foreground-400" />
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700 cursor-pointer">
                  {item.name}
                </Link>
              ) : (
                <span className="font-medium text-foreground-900">{item.name}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}